
import { defineComponent } from "vue";

export default defineComponent({
  name: "Button",
  props: {
    titleButton: {
      type: String,
      required: true,
    },
    iconButton: {
      type: String,
      required: true,
    },
  },
});
